import React from "react";
import CaseIncidentList from "../components/caseIncidentList";
import * as incidentAction from "../../../redux/actions/incidentAction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { API_STATUS } from "../../../constant/constant";
import Loader from "../../../library/common/Loader";
import { useLocation } from "react-router-dom";
import { EDITCASE, CASES } from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { ToastContainer, toast } from "react-toastify";
import BackBtn from "../../../library/custom/backBtn/backBtn";
import { InactiveClient } from "../../../utils/helper";

const CaseIncidentsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const caseState = location?.state;
  const queryString = window.location.search.slice(
    4,
    window.location.search?.length
  );
  // const caseId = location?.state?.caseId ?? queryString;
  const [caseId, setCaseId] = useState( location?.state?.caseId ?? queryString)
  useEffect(() => {
    setCaseId(location?.state?.caseId ?? queryString)
  }, [queryString])
  

  const [page, setPage] = useState(0);
  const [clearMessage, setClearMessage] = useState(false);
  const pageSet = (pageNumber) => {
    setPage(pageNumber);
  };
  const deleteIncidents = (deleteIncedent) => {
    setClearMessage(true);
    dispatch(incidentAction.deleteIncidents(deleteIncedent.reportId));
  };
  const incidentListDelete = useSelector((state) => state.deleteIncidentsData);

  const incidentList = useSelector((state) => state.incidentList);

  const getIncidentListData = (data) => {
    dispatch(incidentAction.getIncidentList({ pageNumber: 1, caseId: caseId }));
  };

  const isListSuccess = useSelector(
    (state) => state.incidentList.isLoading || state.closeIncident.isLoading
  );

  const viewCaseData = useSelector((state) => state?.viewCase?.data);
  const closeIncidentData = useSelector((state) => state.closeIncident);

  const isSuccess = useSelector(
    (state) => state.viewCase.status === API_STATUS.SUCCESS
  );
  useEffect(() => {
    dispatch(incidentAction.getCaseDetails(caseId));
  }, [dispatch,caseId]);

  useEffect(() => {
    if (incidentListDelete?.status === "SUCCESS") {
      getIncidentListData(0);
    } else {
      getIncidentListData(caseId);
    }
  }, [incidentListDelete]);

  useEffect(() => {
    if (closeIncidentData?.status === "SUCCESS") {
      dispatch(
        incidentAction.getIncidentList({ pageNumber: 1, caseId: caseId })
      );
      dispatch(incidentAction.getCaseDetails(caseId));
    }
  }, [closeIncidentData, dispatch]);

  useEffect(() => {
    getIncidentListData(caseId);
  }, [caseId]);

  const handleEditOnClick = () => {
    if (InactiveClient()) return;
    navigate(EDITCASE, {
      state: {
        caseId: caseId,
        editMode: true,
        isEditModeThroughViewCase: false,
      },
    });
  };

  const closeIncidents = (closeIncident) => {
    dispatch(
      incidentAction.closeIncident({ incidentId: closeIncident.reportId })
    );
  };

  useEffect(() => {
    if (
      incidentListDelete?.status === "SUCCESS" &&
      incidentListDelete?.isLoading === false &&
      clearMessage
    ) {
      toast("Incident Deleted successfully");
    }
  }, [incidentListDelete]);

  const dataBack = {
    title: `${
      caseState?.incidentURL ? caseState?.backRouteText : "Back to View Cases"
    }`,
    route: caseState?.incidentURL ? caseState?.incidentURL : CASES,
    state: caseState?.apiData,
  };

  return (
    <>
      {checkPrivileges([1, 2, 3, 149, 150, 151, 12]) ? (
        <>
          {caseState?.incidentURL && (
            <BackBtn dataBack={dataBack} className="equipmentBack" />
          )}
          {isSuccess ? (
            <CaseIncidentList
              pageSet={pageSet}
              incidentList={isListSuccess ? [] : incidentList}
              deleteIncidents={deleteIncidents}
              isFullAccess={checkPrivileges([151, 12])}
              isWriteAccess={checkPrivileges([150, 12])}
              isReadAccess={checkPrivileges([149, 12])}
              isListSuccess={isListSuccess}
              viewCaseData={viewCaseData}
              handleEditOnClick={handleEditOnClick}
              getIncidentListData={getIncidentListData}
              closeIncidents={closeIncidents}
              caseState={caseState}
            />
          ) : (
            <Loader />
          )}
          <ToastContainer />
        </>
      ) : (
        <Loader />
      )}
      <ToastContainer />
    </>
  );
};

export default CaseIncidentsList;
